module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/vhand9-273933cf9ed74d30b7cf1fb1cedc0fda.jpg";